import PropTypes from 'prop-types';
import '../../../styles/reports.css';
import React from 'react';
import QuestionPreviewModal from '../../../../assignments/components/QuestionPreviewModal';
import { generateTableRows } from './generateTableRows';
import { generateTableHeaders } from './generateTableHeaders';

const QuestionsTable = ({
  data,
  persistData
}) => {
  const [openQuestionDetailModel, setOpenQuestionDetailModel] = React.useState(false);
  const [selectedQuestionId, setSelectedQuestionId] = React.useState(0);
  const [assignmentId, setAssignmentId] = React.useState(0);
  const [isPublic, setIsPublic] = React.useState(false);

  const handleQuestionPreview = (questionId, assignmentId, isPublic) => {
    setSelectedQuestionId(questionId);
    setAssignmentId(assignmentId);
    setIsPublic(isPublic);
    setOpenQuestionDetailModel(true);
  };
  
  return (
    <>
      <div id='growthTable' className='mt-4 table-responsive growth-table-scroll-bar'>
        <table className='w-100 text-center growth-table'>
          <thead>
            <tr>
              <th colSpan={persistData.midTestID > 0 ? 5 : 4} className='border'>Questions</th>
              <th className='border' rowSpan={2}>Score<br />Type</th>
              {persistData.studentID > 0 &&
                generateTableHeaders('bg-student-header', persistData.growth, persistData.midTestID > 0)
              }
              {persistData.classID > 0 &&
                generateTableHeaders('bg-class-header', persistData.growth, persistData.midTestID > 0)
              }
              {persistData.teacherID > 0 &&
                generateTableHeaders('bg-teacher-header', persistData.growth, persistData.midTestID > 0)
              }
              {persistData.schoolID > 0 &&
                generateTableHeaders('bg-school-header', persistData.growth, persistData.midTestID > 0)
              }
              {persistData.districtID > 0 &&
                generateTableHeaders('bg-district-header', persistData.growth, persistData.midTestID > 0)
              }
            </tr>
            <tr>
              <th className='border rounded-0'>Pre-Test</th>
              {persistData.midTestID > 0 &&
                <th className='border'>Mid-Test</th>
              }
              <th className='border'>Post-Test</th>
              <th className='border'>Type</th>
              <th className='border'>Max<br />Points</th>
            </tr>
          </thead>
          <tbody>
            {data.map((questionItem, index) => {
              return(<>
                <React.Fragment key={index}>
                  {questionItem.score.map((scoreItem)=>{
                    var thresholdValue = scoreItem.scoreType == 'points' ? persistData.thresholdPoints : persistData.thresholdPercent;
                    var isPercent = scoreItem.scoreType == 'points' ? false : true;
                    var isMidTestEnabled = persistData.midTestID > 0;
                    return (
                      <React.Fragment key={index}>
                        {((persistData.points && scoreItem.scoreType == 'points') || (persistData.percentage && scoreItem.scoreType == 'percentage')) &&
                        <tr>
                          <td className='text-decoration-underline cursor-pointer border' onClick={() => handleQuestionPreview(questionItem.id, questionItem.assignmentId, questionItem.isPublicAssignment)}>{questionItem.preTestQuestionNo}</td>
                          {isMidTestEnabled &&
                            <td className='text-decoration-underline cursor-pointer border' onClick={() => handleQuestionPreview(questionItem.id, questionItem.assignmentId, questionItem.isPublicAssignment)}>{questionItem.midTestQuestionNo}</td>
                          }
                          <td className='text-decoration-underline cursor-pointer border' onClick={() => handleQuestionPreview(questionItem.id, questionItem.assignmentId, questionItem.isPublicAssignment)}>{questionItem.postTestQuestionNo}</td>
                          <td className='border'>{questionItem.type}</td>
                          <td className='border'>{questionItem.maxPoints}</td>
                          
                          <td key={'q'+index} className='border'>{scoreItem.scoreType == 'points' ? 'Points' : '%'}</td>
                          {persistData.studentID > 0 &&
                            generateTableRows(`${scoreItem.scoreType == 'points' ? 'bg-student-points' : 'bg-student-percentage'}`, scoreItem.studentGrowth, thresholdValue, persistData.growth, isMidTestEnabled, isPercent)
                          }
                          {persistData.classID > 0 &&
                            generateTableRows(`${scoreItem.scoreType == 'points' ? 'bg-class-points' : 'bg-class-percentage'}`, scoreItem.classGrowth, thresholdValue, persistData.growth, isMidTestEnabled, isPercent)
                          }
                          {persistData.teacherID > 0 &&
                            generateTableRows(`${scoreItem.scoreType == 'points' ? 'bg-teacher-points' : 'bg-teacher-percentage'}`, scoreItem.teacherGrowth, thresholdValue, persistData.growth, isMidTestEnabled, isPercent)
                          }
                          {persistData.schoolID > 0 &&
                            generateTableRows(`${scoreItem.scoreType == 'points' ? 'bg-school-points' : 'bg-school-percentage'}`, scoreItem.schoolGrowth, thresholdValue, persistData.growth, isMidTestEnabled, isPercent)
                          }
                          {persistData.districtID > 0 &&
                            generateTableRows(`${scoreItem.scoreType == 'points' ? 'bg-district-points' : 'bg-district-percentage'}`, scoreItem.districtGrowth, thresholdValue, persistData.growth, isMidTestEnabled, isPercent)
                          }
                        </tr>
                        }
                      </React.Fragment>
                    );
                  })}
                </React.Fragment>
              </>);
            })}
          </tbody>
        </table>
      </div>
      <QuestionPreviewModal
        isOpen={openQuestionDetailModel}
        onClose={() => setOpenQuestionDetailModel(false)}
        questionId={selectedQuestionId}
        assignmentId={parseInt(assignmentId)}
        isPublicAssignment={isPublic}
      />
    </>
  );
};

QuestionsTable.propTypes = {
  data: PropTypes.array,
  persistData: PropTypes.object
};

export default QuestionsTable;